import styles from "./index.module.css";
import React from "react";
import classNames from "classnames";
import { ChevronDown } from "react-ikonate";

/**
 * Just a plain option selector with some extra styles.
 */
export default function ({ className, children, ...props }) {
  return (
    <div className={styles.container}>
      <select className={classNames(styles.select, className)} {...props}>
        {children}
      </select>
      <div className={styles.icon}>
        <ChevronDown width={24} height={24} />
      </div>
    </div>
  );
}
